// global-hero.js                                            ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

let autoplayResult;

if (typeof autoplayTime !== 'undefined') {
  if (autoplayTime.trim() === 'false') {
    autoplayResult = false;
  } else {
    autoplayResult = JSON.parse('{ "delay":' + autoplayTime + '}');
  }
}

// Global Hero Swiper
export const GlobalHeroSwiper = new Swiper('.global-hero-swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: autoplayResult,
});
